module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst separator = helpers.detectRenderedImage(model.separator, model._separator) || {}\n%><div><%\n%><div class=\"separator\"><%\nif(separator.url){\n%><img src=\"<%- separator.url %>\" alt=\"Separator\"/><%\n}\n%></div><%\n%><div class=\"content\"><%\nif(model.left){\n%><div class=\"left\"><%- model.left %></div><%\n}\nif(model.center){\n%><div class=\"center\"><%- model.center %></div><%\n}\nif(model.right){\n%><div class=\"right\"><%- model.right %></div><%\n}\n%></div><%\n%></div>"
  , __filename = "components/templates/core/static/footer/footer.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const separator = helpers.detectRenderedImage(model.separator, model._separator) || {}

    ; __line = 3
    ; __append("<div>")
    ; 

    ; __line = 4
    ; __append("<div class=\"separator\">")
    ; 
if(separator.url){

    ; __line = 6
    ; __append("<img src=\"")
    ; __append( separator.url )
    ; __append("\" alt=\"Separator\"/>")
    ; 
}

    ; __line = 8
    ; __append("</div>")
    ; 

    ; __line = 9
    ; __append("<div class=\"content\">")
    ; 
if(model.left){

    ; __line = 11
    ; __append("<div class=\"left\">")
    ; __append( model.left )
    ; __append("</div>")
    ; 
}
if(model.center){

    ; __line = 14
    ; __append("<div class=\"center\">")
    ; __append( model.center )
    ; __append("</div>")
    ; 
}
if(model.right){

    ; __line = 17
    ; __append("<div class=\"right\">")
    ; __append( model.right )
    ; __append("</div>")
    ; 
}

    ; __line = 19
    ; __append("</div>")
    ; 

    ; __line = 20
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/static/footer/footer.ejs

}